
document.addEventListener('DOMContentLoaded', () => {
    var headerPath = '/header.html';
    var footerPath = '/footer.html';

    // Function to fetch and add header content
    function addHeader() {
        fetch(headerPath)
            .then(response => response.text())
            .then(html => {
                document.getElementById('header').innerHTML = html;
            })
            .catch(error => console.error('Error loading header:', error));
    }

    // Function to fetch and add footer content
    function addFooter() {
        fetch(footerPath)
            .then(footerResp => footerResp.text())
            .then(footerHtml => {
                const footerElement = document.getElementById('footer');
                footerElement.innerHTML = footerHtml;
                
                // Force multiple reflows and ensure visibility
                footerElement.style.display = 'block';
                footerElement.style.visibility = 'visible';
                footerElement.offsetHeight; // Force reflow
                
                // Trigger a resize event to force layout recalculation
                window.dispatchEvent(new Event('resize'));
            })
            .catch(error => console.error('Error loading footer:', error));
    }

    addHeader();
    addFooter();
});
